export enum ByteSize {
  BYTES,
  KB,
  MB,
}

/* eslint-disable complexity */
export function convertFileSize(
  value: number,
  input: ByteSize,
  output: ByteSize
): number {
  switch (input) {
    case ByteSize.BYTES:
      switch (output) {
        case ByteSize.BYTES:
          return value;
        case ByteSize.KB:
          return value / 1024;
        case ByteSize.MB:
          return value / (1024 * 1024);
        default:
          throw new Error("Invalid output size.");
      }
    case ByteSize.KB:
      switch (output) {
        case ByteSize.BYTES:
          return value * 1024;
        case ByteSize.KB:
          return value;
        case ByteSize.MB:
          return value / 1024;
        default:
          throw new Error("Invalid output size.");
      }
    case ByteSize.MB:
      switch (output) {
        case ByteSize.BYTES:
          return value * 1024 * 1024;
        case ByteSize.KB:
          return value * 1024;
        case ByteSize.MB:
          return value;
        default:
          throw new Error("Invalid output size.");
      }
    default:
      throw new Error("Invalid input size");
  }
}
/* eslint-enable complexity */
